<template>
	<div class="task-result" :class="resultData.status">
		<div class="result-content">
			<i :class="resultIcon" class="result-icon"></i>
			<span class="result-message">{{ resultData.message }}</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TaskResult',
	props: {
		resultData: {
			type: Object, // TaskResult: { status: 'success'|'error', message: string, data?: any }
			required: true
		}
	},
	computed: {
		resultIcon() {
			return this.resultData.status === 'success'
				? 'el-icon-success'
				: 'el-icon-error';
		}
	}
}
</script>

<style scoped lang="scss">
.task-result {
	padding: 12px;
	border-radius: 6px;
	margin-top: 8px;

	&.success {
		background: #f0f9ff;
		border: 1px solid #67c23a;

		.result-icon {
			color: #67c23a;
		}

		.result-message {
			color: #67c23a;
		}
	}

	&.error {
		background: #fef0f0;
		border: 1px solid #f56c6c;

		.result-icon {
			color: #f56c6c;
		}

		.result-message {
			color: #f56c6c;
		}
	}

	.result-content {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.result-icon {
		font-size: 20px;
		flex-shrink: 0;
	}

	.result-message {
		font-size: 14px;
		line-height: 1.5;
		flex: 1;
	}
}
</style>
